import styled from 'styled-components'

export interface IInputFileStyles {
  justifyContent?: string
  alignItems?: string
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  gap?: string
}

export const ContainerInput = styled.div<IInputFileStyles>`
  display: flex;
  flex-direction: column;

  input[type='file'] {
    display: none;
  }
`
